var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 2.00025C22.75 1.38231 22.1951 0.912265 21.5856 1.01385L7.0856 3.43052C6.60341 3.51088 6.25 3.92807 6.25 4.41691V16.7049C5.62325 16.2341 4.8442 15.9551 4 15.9551C1.92893 15.9551 0.25 17.6341 0.25 19.7051C0.25 21.7762 1.92893 23.4551 4 23.4551C6.07107 23.4551 7.75 21.7762 7.75 19.7051V9.36179L21.25 7.56179V13.7049C20.6233 13.2341 19.8442 12.9551 19 12.9551C16.9289 12.9551 15.25 14.6341 15.25 16.7051C15.25 18.7762 16.9289 20.4551 19 20.4551C21.0711 20.4551 22.75 18.7762 22.75 16.7051V2.00025ZM21.25 6.04851V2.59048L7.75 4.84048V7.84852L21.25 6.04851ZM4 17.4551C5.24264 17.4551 6.25 18.4625 6.25 19.7051C6.25 20.9478 5.24264 21.9551 4 21.9551C2.75736 21.9551 1.75 20.9478 1.75 19.7051C1.75 18.4625 2.75736 17.4551 4 17.4551ZM21.25 16.7051C21.25 15.4625 20.2426 14.4551 19 14.4551C17.7574 14.4551 16.75 15.4625 16.75 16.7051C16.75 17.9478 17.7574 18.9551 19 18.9551C20.2426 18.9551 21.25 17.9478 21.25 16.7051Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenActive);
export default __webpack_public_path__ + "static/media/listen-active.78266a9c7db3edc90481caef7e57e81d.svg";
export { ForwardRef as ReactComponent };